import classNames from 'classnames'
import React from 'react'
import styles from './button.module.css'

export function Button(props) {
  const { children, size, className, color, variant, iconOnly, icon, ...restProps } = props;

    const classes = classNames(
        styles.btn,
        styles[`btn-${variant}`],
        styles[`btn-${color}`],
        {
            [`${styles['btn-icon-only']}`]: iconOnly,
            [`${styles[`btn-${size}`]}`]: size,
        },
        className
    )

  return (
    <button type="button" className={classes} {...restProps}>
      {icon && <span className={styles.icon}>{icon}</span>}
      {!iconOnly && children}
    </button>
  );
}

Button.defaultProps = {
    variant: 'contained',
    color: 'primary',
    iconOnly: false,
    size: 'md',
}
